// Bidcloud - HttpService.js

/*

// GET con query params
const r1 = await HttpService.GET('/Index?handler=GetProducts', { params: { page: 1, q: 'cable' } });

//si vuelve un html
const { data: data } = await HttpService.GET(`/API/Catalog/GetSection?tableid=${TableID}&rendered=true`,
    { dataType: 'html' }
);


// POST JSON
const r2 = await HttpService.POST('/Index?handler=Save', { id: 1, name: 'Item' });

// Upload (FormData)
const fd = new FormData();
fd.append('file', fileInput.files[0]);
const r3 = await HttpService.upload('/Index?handler=UploadImage', fd);

*/

(function () {
    const isJson = (ct) => /application\/json/i.test(ct || '');
    const toQuery = (obj = {}) =>
        Object.entries(obj)
            .filter(([, v]) => v !== undefined && v !== null)
            .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
            .join('&');

    const getCsrf = () => {
        const el = document.querySelector('input[name="__RequestVerificationToken"]');
        return el ? el.value : null;
    };

    const safeStartOverlay = (m) => { try { startAjaxScreen?.(m); } catch (_) { } };
    const safeStopOverlay = () => { try { stopAjaxScreen?.(); } catch (_) { } };

    const defaults = {
        baseUrl: '',
        headers: {},
        timeout: 30000,
        withOverlay: true,
        retries: 0,            // cantidad de reintentos (0 = sin retry)
        retryDelayMs: 600,     // delay base para backoff
    };

    async function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

    async function request(method, url, options = {}) {
        const {
            params,
            data,
            headers,
            contentType = 'application/json; charset=utf-8',
            dataType = 'json',
            timeout = defaults.timeout,
            withOverlay = defaults.withOverlay,
            processData,          // para FormData: false
            retries = defaults.retries,
            retryDelayMs = defaults.retryDelayMs,
        } = options;

        // Construye URL final
        const base = options.baseUrl ?? defaults.baseUrl ?? '';
        let finalUrl = base ? base.replace(/\/$/, '') + '/' + url.replace(/^\//, '') : url;
        if (params && Object.keys(params).length) {
            finalUrl += (finalUrl.includes('?') ? '&' : '?') + toQuery(params);
        }

        // Headers
        const hdrs = Object.assign({}, defaults.headers, headers || {});
        const csrf = getCsrf();
        if (csrf && !hdrs['RequestVerificationToken']) {
            hdrs['RequestVerificationToken'] = csrf;
        }

        // Payload
        let payload = data;
        const isFormData = (typeof FormData !== 'undefined') && (data instanceof FormData);

        const ajaxOptsBase = {
            type: method.toUpperCase(),
            url: finalUrl,
            headers: hdrs,
            timeout,
            dataType,
            beforeSend: () => {
                if (withOverlay) safeStartOverlay(options.loadingMessage || 'Cargando…');
                startLoadingRing();
                displayProgressBar();
            },
            complete: () => {
                if (withOverlay) safeStopOverlay();
                stopLoadingRing();
                removeProgressBar();
            },
        };

        let ajaxOpts;
        if (isFormData) {
            // Subida de archivos
            ajaxOpts = {
                ...ajaxOptsBase,
                data: payload,
                processData: false,
                contentType: false
            };
        } else if (method.toUpperCase() === 'GET') {
            ajaxOpts = { ...ajaxOptsBase, contentType, data: undefined };
        } else {
            ajaxOpts = {
                ...ajaxOptsBase,
                contentType,
                processData: processData ?? !isJson(contentType),
                data: isJson(contentType) ? JSON.stringify(payload ?? {}) : payload
            };
        }

        // Intenta con reintentos simples para 5xx/429
        let attempt = 0;
        /* eslint-disable no-constant-condition */
        while (true) {
            try {
                const res = await new Promise((resolve, reject) => {
                    $.ajax({
                        ...ajaxOpts,
                        success: function (resp, textStatus, jqXHR) {
                            resolve({ data: resp, status: jqXHR.status, xhr: jqXHR });
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            const errPayload = (() => {
                                // Intenta parsear JSON de error si viene en texto
                                const ct = jqXHR.getResponseHeader && jqXHR.getResponseHeader('Content-Type');
                                if (ct && /application\/json/i.test(ct)) {
                                    try { return JSON.parse(jqXHR.responseText); } catch (_) { }
                                }
                                return jqXHR.responseJSON ?? jqXHR.responseText ?? errorThrown ?? textStatus;
                            })();
                            reject({
                                status: jqXHR.status || 0,
                                data: errPayload,
                                xhr: jqXHR,
                                textStatus,
                            });
                        }
                    });
                });
                return res; // éxito
            } catch (err) {
                const retriable = [429, 500, 502, 503, 504].includes(err.status);
                if (attempt < retries && retriable) {
                    attempt++;
                    const wait = retryDelayMs * Math.pow(2, attempt - 1);
                    await sleep(wait);
                    continue;
                }
                throw err; // sin retry o agotado
            }
        }
    }

    // API pública
    window.HttpService = {
        configure(opts = {}) {
            Object.assign(defaults, opts || {});
        },
        request,
        GET: (url, opts = {}) => request('GET', url, opts),
        DELETE: (url, data, opts = {}) => request('DELETE', url, { ...opts, data }),
        POST: (url, data, opts = {}) => request('POST', url, { ...opts, data }),
        PUT: (url, data, opts = {}) => request('PUT', url, { ...opts, data }),
        PATCH: (url, data, opts = {}) => request('PATCH', url, { ...opts, data }),
        // Subida con FormData
        upload: (url, formData, opts = {}) =>
            request('POST', url, { ...opts, data: formData, contentType: false, processData: false }),
    };
})();

(function () {
    let __activeAjaxCount = 0;

    function ensureOverlayDom() {
        let ov = document.getElementById('ajax-overlay');
        if (!ov) {
            ov = document.createElement('div');
            ov.id = 'ajax-overlay';
            ov.setAttribute('aria-hidden', 'true');
            document.body.appendChild(ov);
        }
        if (!ov.querySelector('.ajax-center')) {
            ov.innerHTML = `
        <div class="ajax-center" role="status" aria-live="polite" aria-atomic="true">
          <div class="loader" aria-hidden="true"></div>
          <div class="ajax-text" id="ajax-text"></div>
        </div>`;
        }
        return ov;
    }

    window.setAjaxMessage = function (msg = '') {
        const ov = ensureOverlayDom();
        const t = ov.querySelector('#ajax-text');
        if (t) t.textContent = msg || '';
    };

    window.startAjaxScreen = function (msg) {
        __activeAjaxCount++;
        document.documentElement.classList.add('is-ajax');
        document.body.classList.add('is-ajax');
        ensureOverlayDom();
        setAjaxMessage(msg);
    };

    window.stopAjaxScreen = function () {
        __activeAjaxCount = Math.max(0, __activeAjaxCount - 1);
        if (__activeAjaxCount === 0) {
            var overlay = document.getElementById('ajax-overlay');
            if (overlay) overlay.remove()
        }
    };
})();
